export default __webpack_public_path__ + "resources/icons/d421-dcbd.png";